import React from "react";
import { useState, useEffect } from "react";
import { TitleComponent, CardComponent, TableComponent, ButtonActionComponent, ButtonGenerateBaseComponent, SelectComponent, SelectComponentMulti } from '../../../components/pages/index';
import { api, apiConfig } from "../../../util/api";
import { useGetApiWs } from '../../../hooks/index';

const Base = (props) => {

    const urlCustomer = useGetApiWs('admin', 'entity', 'company-get');
    const urlCustonerInfo = useGetApiWs('admin', 'entity', 'customer-get');
    const urlFilter = useGetApiWs('admin', 'entity', 'analysis-base-get');

    const [defMeasurements, setDefMeasurements] = useState([]);

    const [customers, setCustomers] = useState([]);
    const [category, setCategory] = useState([]);
    const [measurement, setMeasurement] = useState([]);

    const [lbCategory, setLbCategory] = useState(null);
    const [lbCustomer, setLbCustomer] = useState(null);
    const [lbMeasurement, setLbMeasurement] = useState(null);

    const [customerIsLoading, setCustomerIsLoading] = useState(true);
    const [categoryIsLoading, setCategoryIsLoading] = useState(true);
    const [measurementLoading, setMeasurementIsLoading] = useState(true);

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [btnExports, setBtnExports] = useState(false);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbPending, setTbPending] = useState(false);

    const wbname = "Excel"

    const fetchCustomers = async () => {
        const customers = await api().post(urlCustomer, { company_type_code: 'CM-CUST' }, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.company_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setCustomers(options);
        setCustomerIsLoading(false);
        CustomerChange({ 'value': 3, 'label': 'ALICORP' })
    }
    const fetchCategory = async (customer_id) => {

        const ob = {};
        ob['customer_id'] = customer_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'categories';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
        if (cWorkOrders.status === 200 && cWorkOrders.data.status === 'success') {
            var options = cWorkOrders.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.category_name;
                return rObj;
            })
            setCategory(options);
        }
        setCategoryIsLoading(false);
    }
    const fetchMeasurement = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'measurements';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const measurement = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = measurement.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.measurement_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setMeasurement(options);
        setMeasurementIsLoading(false);
    }


    const CustomerChange = async vals => {
        setLbCustomer(vals);
        if (vals === null) {
            setCategory([]);
            setLbCategory(null);
        } else {
            setCategory([]);
            setLbCategory(null);
            fetchCategory(vals.value);
        }
    }

    const CategoryChange = async vals => {
        ClearForm();
        setLbCategory(vals);
        if (vals != null) {
            fetchMeasurement(vals.value, lbCustomer.value);
        }
    }

    const MeasurementChange = async vals => {
        setLbMeasurement(vals);
    }

    const Filter = () => {
        fetchFilters();
    }
    const ClearForm = () => {
        setMeasurement([]);
        setLbMeasurement([]);
        setDefMeasurements([]);
        setMeasurementIsLoading(false);
        setBtnExports(false);
        setTbData([]);
        setTbPending(false);
    }

    const fetchFilters = async () => {
        if (lbCategory != null) {
            setTbPending(true);
            const ob = {};
            ob['customer_id'] = lbCustomer.value;
            ob['category_id'] = lbCategory.label + '|' + lbCategory.value + '|';

            const mea = lbMeasurement.map((obj) => { return obj.label + '|' + obj.value + '|'; });

            ob['measurements'] = mea.join(',');

            var headers = [];
            const res = await api().post(urlFilter, ob, apiConfig());
            if (res.data.status === 'success') {
                let colum = [];
                if (res.data.response.length > 0) {
                    const head = res.data.response[0]
                    headers = Object.keys(head)
                    for (var h in headers) {
                        colum.push({
                            name: headers[h], selector: headers[h], sortable: false, wrap: true
                        })
                    }
                    setBtnExports(true);
                    setTbColumns(colum);
                    setTbData(res.data.response);
                    setTbPending(false);
                } else {
                    setBtnExports(false);
                    setTbColumns([]);
                    setTbData([]);
                    setTbPending(false);
                }
            }
        } else {
            return null;
        }
    }

    useEffect(() => {
        fetchCustomers();
    }, []);

    return (
        <div>
            <TitleComponent title="GENERAR BASE" />
            <div className="pt-3">
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2">
                        <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4">
                            <SelectComponent onChange={CustomerChange} options={customers} value={lbCustomer} isLoading={customerIsLoading} label="Clientes" isDisabled={true} />
                            <SelectComponent onChange={CategoryChange} options={category} value={lbCategory} isLoading={categoryIsLoading} label="Categoría" />
                            <SelectComponentMulti onChange={(vals) => { MeasurementChange(vals) }} options={measurement} value={lbMeasurement} label="Medición" />
                        </div>
                        <div className="bg-white p-2 justify-items-end grid">
                            <div className="space-x-4">
                                <ButtonActionComponent name="GENERAR REPORTE" onClick={Filter} />
                                {(btnExports) ? <ButtonGenerateBaseComponent name="EXPORTAR EXCEL" onClick={props.createDataExcel} tbColumns={tbColumns} tbData={tbData} lbCustomer={lbCustomer} lbMeasurement={lbMeasurement} lbCategory={lbCategory} wbname={wbname} /> : null}
                            </div>
                        </div>
                    </div>
                </CardComponent>
            </div>

            <div className="pt-3">
                <CardComponent header={<h4 className="">BASE</h4>} footer={null}>
                    <div className="bg-white">
                        <div>

                        </div>
                        <TableComponent
                            keyField="work_order_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                        />
                    </div>
                </CardComponent>
            </div>
        </div>
    )
}
export default Base;